import { nanoidBrowser } from '@naturalcycles/js-lib'
import { UserDeviceSaveInput } from '@naturalcycles/shared'
import { storageService } from './storage.service.js'

const STORAGE_KEY = 'app_user_device_id'

class UserDeviceService {
  getUserDeviceInput(): UserDeviceSaveInput {
    return {
      res: [window.screen.width, window.screen.height].join('x'),
    }
  }

  deviceId(): string {
    let id = storageService.get(STORAGE_KEY)
    if (id) return id

    id = nanoidBrowser()
    storageService.put(STORAGE_KEY, id)
    return id
  }
}

export const userDeviceService = new UserDeviceService()
